/**
 * ------------------------------
 * JS Vendor Imports
 * ------------------------------
 */
import 'bootstrap-legacy';

import '../vendor/jquery-ui/jquery-ui-1.10.3.custom.min';
import '../vendor/bootstrap-datetimepicker/bootstrap-datetimepicker.min';
import '../vendor/placeholders/placeholders.min';
import '../vendor/sprintf/sprintf';

import '../app-lite/app.module.ajs';

import './admin-dashboard/admin-dashboard.module.ajs';
import './ams-rewards/ams-rewards.module';
import './ashdown/ashdown.module';
import './assembly-payments/assembly-payments.module.ajs';
import './booking-diary/booking-diary.module';
import './bookings/bookings.module.ajs';
import './branches/branches.module';
import './burson/burson.module.ajs';
import './capricorn/capricorn.module';
import './celero/celero.module';
import './checka/checka.module.ajs';
import './communication-center/communication-center.module';
import './companies/companies.module.ajs';
import './core/core.module';
import './countries/countries.module.ajs';
import './credits/credits.module';
import './customers/customers.module.ajs';
import './dashboard/dashboard.module.ajs';
import './dealers/dealers.module';
import './dealership/dealership.module.ajs';
import './events/events.module.ajs';
import './export/export.module';
import './hsy/hsy.module';
import './imports/imports.module';
import './inspections/inspections.module.ajs';
import './invoice-items/invoice-items.module';
import './invoices/invoices.module';
import './invoices/vendor-invoices.module';
import './labor-items/labor-items.module';
import './mailchimp/mailchimp.module';
import './mechanics/mechanics.module.ajs';
import './messages/messages.module';
import './mitchell1/mitchell1.module';
import './myob/myob.module';
import './oscar/oscar.module';
import './parts-authority/parts-authority.module';
import './price-matrix/price-matrix.module';
import './products/products.module.ajs';
import './prolink/prolink.module';
import './purchase-orders/purchase-orders.module.ajs';
import './quickbooks/quickbooks.module';
import './repco/repco.module';
import './reports/reports.module.ajs';
import './schedule/schedule.module.ajs';
import './settings/settings.module';
import './statements/statements.module';
import './stock-take/stock-take.module.ajs';
import './stripe/stripe.module.ajs';
import './tireconnect/tireconnect.module';
import './tiremetrix/tiremetrix.module';
import './units/units.module';
import './users/users.module.ajs';
import './vehicle-groups/vehicle-groups.module';
import './vehicle-registrations/vehicle-registrations.module.ajs';
import './vehicle-visuals/vehicle-visuals.module.ajs';
import './vehicles/vehicles.module.ajs';
import './vendor-credits/vendor-credits.module';
import './vendors/vendors.module.ajs';
import './vv-garage/vv-garage.module';
import './xero/xero.module';

angular.module('workshop', [
  'app-lite',
  'workshop.adminDashboard',
  'workshop.amsRewards',
  'workshop.ashdown',
  'workshop.assembly-payments',
  'workshop.booking',
  'workshop.bookings',
  'workshop.branches',
  'workshop.burson',
  'workshop.capricorn',
  'workshop.checka',
  'workshop.communication-center',
  'workshop.company',
  'workshop.core',
  'workshop.countries',
  'workshop.credits',
  'workshop.customerPayments',
  'workshop.customers',
  'workshop.dashboard',
  'workshop.dealers',
  'workshop.dealership',
  'workshop.events',
  'workshop.export',
  'workshop.hsy',
  'workshop.imports',
  'workshop.inspections',
  'workshop.invoiceItems',
  'workshop.invoices',
  'workshop.laborItems',
  'workshop.mailchimp',
  'workshop.mechanics',
  'workshop.messages',
  'workshop.mitchell1',
  'workshop.myob',
  'workshop.oscar',
  'workshop.parts-authority',
  'workshop.priceMatrix',
  'workshop.products',
  'workshop.prolink',
  'workshop.purchaseOrders',
  'workshop.quickbooks',
  'workshop.repco',
  'workshop.reports',
  'workshop.schedule',
  'workshop.settings',
  'workshop.statements',
  'workshop.stockTake',
  'workshop.stripe',
  'workshop.tireconnect',
  'workshop.tiremetrix',
  'workshop.celero',
  'workshop.units',
  'workshop.users',
  'workshop.vehicle-registrations',
  'workshop.vehicle-visuals',
  'workshop.vehicles.groups',
  'workshop.vehicles',
  'workshop.vendorCredits',
  'workshop.vendorInvoices',
  'workshop.vendors',
  'workshop.vv-garage',
  'workshop.xero'
]);
